<script>
    import Spinner from 'views/components/spinner/Spinner.svelte';
    import SectionSlot from './sectionSlot/SectionSlot.svelte';
    import StatusCard from 'views/components/statusCard/StatusCard.svelte';
    import { onMount } from 'svelte';
    import HeroButton from 'views/components/heroButton/HeroButton';
    import SetVisibility from 'views/components/modals/setVisibility/SetVisibility';
    import {createContentDomainFilterHeroDropdown} from 'views/components/contentDomainDropdown/ContentDomainDropdown';

    export let params

    const model = Backbone.Collection.chapters.get(parseInt(params[0]))
    let isLoading

    Backbone.View.header.clearButtons()
    Backbone.View.header.setTitle(model.getName('show'))
    Backbone.View.header.setCrumblepath(
        model.getAllCrumblepathModels(),
        'show'
    )

    if (ACL.checkRole(ACL.roles.TEACHER) && !Backbone.Model.user.get('exam_product')) {
        Backbone.View.header.addButton(
            new HeroButton({
                firstLine: window.i18n.gettext('Set visibility'),
                icon: 'eye',
                callback: () => {
                    Backbone.View.Components.modal.open(SetVisibility, {
                        title: window.i18n.gettext('Set visibility'),
                        model
                    })
                }
            })
        )
        getProgress()
    }

    if (ACL.checkRole(ACL.roles.STUDENT)) {
        const contentDomain = model.getContentDomain()
        if (contentDomain) {
            createContentDomainFilterHeroDropdown(
                model,
                (selectedContentDomainId) => getProgress(selectedContentDomainId)
            )
        } else {
            getProgress()
        }
    }

    onMount(() => {
        Backbone.View.header?.setBackgroundImage(model)

        return () => {
            Backbone.View.header?.removeBackgroundImage()
        }
    })

    function getProgress(contentDomainItemId = null) {
        isLoading = true
        let url = '/chapters/get_sections_progress/' + model.id + '.json'
        if (Number.isInteger(contentDomainItemId)) {
            url += '?content_domain_item_id=' + contentDomainItemId
        }
        jQuery.get({
            url,
            success: (response) => {
                for (const section of response.sections || []) {
                    model.sections.get(section.section_id)?.set({
                        progress: section.progress,
                        hasExemption: section.hasExemption,
                    })
                }
            },
            error: (response) => {
                response.failSilently = true
            },
            complete: () => {
                isLoading = false
            }
        })
    }
</script>

<div class="center-panel container">
    {#if isLoading}
        <div class="spinner">
            <Spinner></Spinner>
        </div>
    {:else}

        {#each model.sections.models as sectionModel (sectionModel.id)}
            <SectionSlot model={sectionModel}></SectionSlot>
        {:else}
            <StatusCard icon="info-circle">
                {window.i18n.gettext('This chapter doesn\'t have any content yet.')}
            </StatusCard>
        {/each}

    {/if}
</div>

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.container {
  margin-bottom: 48px;
}

.spinner {
  margin-top: 48px;
  color: hsl(40, 4%, 84%);
}</style>
